export default "__VITE_ASSET__1da7ca0a__"